import React, { useEffect, useState } from 'react'
import { useIonViewDidEnter, useIonViewDidLeave } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { getNarrativeSelector } from '../selectors/narrative.selector'
import { setNarrativeText, setNarrativeTextPNNV } from '../store/narrative.actions'
import { NarrativeConstants } from '../store/narrative.constants'
import './PatientNarrative.content.css'
import { IPHIComponent } from '../../../components/phi/phi.component'
import TextArea from '../../../components/textArea/TextArea.component'
import { IPNNVOption } from '../../../common/common.types'
import { getAllPNNVOptionsSelector } from '../../options/selectors'

const PatientNarrativeContent: React.FC<IPHIComponent> = (props: IPHIComponent) => {
  const patientNarrative = useSelector(getNarrativeSelector)
  const { t } = useTranslation()
  const { isPHI } = props
  const dispatch = useDispatch()
  const onChange = (e: CustomEvent) => {
    dispatch(setNarrativeText(e.detail.value))
  }
  const [flag, setFlag] = useState(true)
  const allPNNVOptions = useSelector(getAllPNNVOptionsSelector)
  const eNarrative01Options = allPNNVOptions?.['eNarrative.01']

  const setNarrativeTextPNNVOnChange = (pnnvOption: IPNNVOption) => {
    dispatch(setNarrativeTextPNNV(pnnvOption))
  }

  useEffect(() => {
    if (flag) {
      patientNarrative.narrativeText && dispatch(setNarrativeText(patientNarrative.narrativeText))
    }
  }, [flag])

  useIonViewDidEnter(() => {
    setFlag(true)
  })

  useIonViewDidLeave(() => {
    setFlag(false)
  })

  return (
    <TextArea
      isPHI={isPHI}
      dataTestID='Narrative'
      label={t('narrative.narrativeLabel')}
      rows={8}
      maxlength={10000}
      value={patientNarrative?.narrativeText}
      validationId={NarrativeConstants.SET_NARRATIVE_TEXT}
      onChangeAction={(e) => onChange(e)}
      pnnvOptions={eNarrative01Options}
      pnnvValue={patientNarrative?.narrativeTextPNNV}
      pnnvAction={setNarrativeTextPNNVOnChange}
      pnnvLabel={t('narrative.narrativePNNVLabel')}
      pnnvListHeader={t('narrative.narrativeListHeader')}
      pnnvShowConfirmation={patientNarrative?.narrativeText.length > 0}
    />
  )
}

export default PatientNarrativeContent
